import { ScaffoldFooter } from "@repo/core/components/layout/Scaffolds/components/ScaffoldFooter";
import { PageScaffold } from "@repo/core/components/layout/Scaffolds/PageScaffold";
import { SelectFinancialServiceList } from "@repo/core/components/layout/SelectFinancialServiceList";

import { FinancialServiceController } from "./controller";
import { View } from "@gluestack-ui/themed";

export const FinancialService = () => {
  const {
    handleOnSubmitForm,
    back,
    financialServices,
    isLoadingFinancialServices,
    selectedIdFinancialService,
    handleSelectFinancialService
  } = FinancialServiceController();

  return (
    <PageScaffold
      onBackPress={back}
      onPressRightIcon={back}
      rightWebLabel="Fechar"
      title="Serviços financeiros"
      footerContent={
        <ScaffoldFooter
          primaryText="Continuar"
          primaryAction="primary"
          primaryOnPress={handleOnSubmitForm}
          secondaryText="Cancelar"
          secondaryOnPress={back}
        />
      }
    >
      <View flex={1} w="$full" h="$full">
        <SelectFinancialServiceList
          isLoading={isLoadingFinancialServices}
          financialServices={financialServices || []}
          selectedFinancialService={selectedIdFinancialService || null}
          onSelectFinancialService={handleSelectFinancialService}
        />
      </View>
    </PageScaffold>
  );
};
